import { getUrlParamsByObject } from 'Utils/url';
import { httpClientNotification } from './microservice-http-clients';

export const getNotifications = (channel, limit, offset) => (
  httpClientNotification.get(`/messages${getUrlParamsByObject({ channel, limit, offset })}`)
);
